import { Dispatch, FC, SetStateAction } from 'react';
import styled from 'styled-components';
import { Icon } from '../../../style/Icon';

type PaginationProps = {
  currentPage: number;
  setCurrentPage: Dispatch<SetStateAction<number>>;
  totalPages: number;
};

const PageControls: FC<PaginationProps> = (props) => {
  const goToPrevPage = (): void => {
    if (props.currentPage > 1) {
      const currentPage = props.currentPage - 1;
      props.setCurrentPage(currentPage);
    }
  };

  const goToNextPage = (): void => {
    if (props.currentPage < props.totalPages) {
      const currentPage = props.currentPage + 1;
      props.setCurrentPage(currentPage);
    }
  };

  return (
    <Wrapper data-testid='left-right-controls'>
      <Button
        isActive={props.currentPage > 1}
        data-testid='left-control'
        onClick={goToPrevPage}
        className={props.currentPage > 1 ? 'test-btn-enabled' : 'test-btn-disabled'}
      >
        <Icon type='angle-left' size={18} className='-icon' />
      </Button>
      <Button
        isActive={props.currentPage < props.totalPages}
        data-testid='right-control'
        onClick={goToNextPage}
        className={props.currentPage < props.totalPages ? 'test-btn-enabled' : 'test-btn-disabled'}
      >
        <Icon type='angle-right' size={18} className='-icon' />
      </Button>
    </Wrapper>
  );
};

export default PageControls;

const Wrapper = styled.div`
  border: 1px solid ${(props) => props.theme.palette.lightGrey};
  border-radius: 3px;
  width: 84px;
  margin-right: 0.5em;
  margin-left: 0.5rem;
`;

type ButtonProps = {
  isActive?: boolean;
};

const Button = styled.button<ButtonProps>`
  background: ${(props) => (props.isActive ? props.theme.palette.white : props.theme.palette.gray)};
  border: none;
  width: 50%;
  height: 100%;

  .-icon {
    color: ${(props) =>
      props.isActive ? props.theme.palette.grayTwo : props.theme.palette.lightGreyTwo};
    vertical-align: text-top;
  }
`;
